<template lang="">
  <div v-if="show" class="element-toast-notification is--banner">
    <div v-if="bannerIcon === 'success'" class="element-featured-icon is--sm is--success">
      <svg class="element-icon--check-circle element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-check-circle"></use></svg>
    </div>
    <div v-else-if="bannerIcon === 'warning'" class="element-featured-icon is--sm is--warning">
      <svg class="element-icon--warning element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-warning"></use></svg>
    </div>
    <div v-else-if="bannerIcon === 'error'" class="element-featured-icon is--sm is--error">
      <svg class="element-icon--warning element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-error"></use></svg>
    </div>
    <div class="element-toast-notification__body">
      <h3 class="element-toast-notification__title">{{ bannerTitle }}</h3>
      <p>{{ bannerDescription }}</p>
    </div>
    <div v-if="dismissable" class="element-toast-notification__footer">
      <div class="element-button--icon element-button"
        @click="close">
        <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
      </div>
    </div>
  </div>
</template>

<script>

// import api from '../api/publisher'
export default {
  name: 'ProjectSourceBanner',
  props: {
    bannerTitle: {
      type: String,
      default: () => 'Golden Source'
    },
    bannerDescription: {
      type: String,
      default: () => 'Analysis is complete and your Golden Source is ready to use when creating courses. Be sure to review the generated topics and domains first by clicking "Review Golden Source" and exclude unnecessary items, as appropriate. Note that excluded topics won\'t be used in course generation.'
    },
    bannerIcon: {
      type: String,
      default: () => 'success'
    },
    project: {
      type: Object
    },
    showBanner: {
      type: Boolean,
      default: true
    },
    dismissable: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      this.show = false
    },
  },
  computed: {
    
  },
  created() {

  },
}
</script>
